import {JumperPiece} from "./jumperPiece";
import {QUEEN_BLACK, QUEEN_WHITE} from "./svg";

export class Queen extends JumperPiece {
    name = 'queen';
    directions = [[-1, -1], [-1, +1], [+1, -1], [+1, +1], [0, +1], [0, -1], [+1, 0], [-1, 0]];
    svgBlack = QUEEN_BLACK;
    svgWhite = QUEEN_WHITE;

    getDirections() {
        return this.directions;
    }

    clone() {
        const result = new Queen();
        super.clone(result);
        return result;
    }
}